import React, { useEffect } from 'react';
import { analytics } from "./firebase";
import { logEvent } from "firebase/analytics";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "./styles.scss";
import profileImage from './assets/home_icon.png';
import Navbar from './components/Navbar';
import FeaturedProjects from './components/FeaturedProjects';
import Projects from './components/Projects';
import Skill from './components/Skill';
import About from './components/About';
import { useLanguage } from './context/LanguageContext';

function App() {
    const currentYear = new Date().getFullYear();
    const { language, t } = useLanguage();

    useEffect(() => {
        document.documentElement.lang = language === 'pt' ? 'pt-BR' : 'en';
        document.title = t.meta.title;

        const setMetaContent = (selector, value) => {
            const element = document.querySelector(selector);
            if (element) {
                element.setAttribute('content', value);
            }
        };

        setMetaContent('meta[name="description"]', t.meta.description);
        setMetaContent('meta[property="og:title"]', t.meta.ogTitle);
        setMetaContent('meta[property="og:description"]', t.meta.ogDescription);
        setMetaContent('meta[name="twitter:title"]', t.meta.twitterTitle);
        setMetaContent('meta[name="twitter:description"]', t.meta.twitterDescription);
    }, [language, t]);

    return (
        <div>
            <Navbar />
            <div className="container">
                <div className="d-flex align-items-center hero-section" id="home">
                    <div className="row align-items-center d-flex justify-content-between w-100 hero-content-row">
                        <div className="col-md-6">
                            <div className="text-left">
                                <p className="text-uppercase text-white-50 mb-2 hero-eyebrow">{t.hero.eyebrow}</p>
                                <h1 className="text-wrap">{t.hero.title}</h1>
                                <p className="w-100 text-white text-break hero-description">{t.hero.description}</p>
                                <div className="d-flex flex-wrap gap-3 mt-4">
                                    <a
                                        className="btn btn-light"
                                        href="https://www.linkedin.com/in/abraaoan/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                            logEvent(analytics, "lets_talk_click", { platform: "LinkedIn" });
                                        }}
                                    >
                                        {t.hero.primaryCta}
                                    </a>
                                    <a className="btn btn-outline-light" href="#featured">{t.hero.secondaryCta}</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 text-center">
                            <img className="img-fluid hero-image" src={profileImage} alt={t.hero.imageAlt} />
                        </div>

                    </div>
                </div>

                <div id="featured" className="section-anchor section-gap-sm">
                    <FeaturedProjects />
                </div>

                <div id="experience" className="section-anchor section-gap">
                    <Projects />
                </div>

                <div id="skills" className="section-anchor section-gap">
                    <Skill />
                </div>

                <div id="about" className="section-anchor section-gap">
                    <About />
                </div>

                <footer className="site-footer">
                    <p className="site-footer-text">© {currentYear} {t.footer.copyrightLabel}</p>
                </footer>

            </div>
        </div>
    );
}

export default App;
